module.exports = require("plugin-liverig/shared/asset/components/AssetProfile");